import {
    doppeActionTypeCreateSettingsResolvingFunction,
    doppeActionTypeDefineMetadata
} from '../../client-server-common/doppe-action-types/doppe-action-type';
import type {Values} from '@wix/devzai-utils-common';
import {BymoPagePropsSpecialContentSettingMetadata} from '../../client-server-common';

export const DoppeActionTypeSubscribeEmbedSubscribeType = {
    Substack: 'substack',
} as const;

export type DoppeActionTypeSubscribeEmbedSubscribeType = Values<typeof DoppeActionTypeSubscribeEmbedSubscribeType>;


export namespace DoppeActionTypeSubscribeEmbed {


    export interface ActionSettings {
        userId: string;
        subscribeType: DoppeActionTypeSubscribeEmbedSubscribeType
    }


}

export const doppeActionTypeSubscribeEmbed = doppeActionTypeDefineMetadata<DoppeActionTypeSubscribeEmbed.ActionSettings>({
    id: 'io.bymo.action/subscribe-embed',
    resolveActionSettings: doppeActionTypeCreateSettingsResolvingFunction({
        userId: '',
        subscribeType: DoppeActionTypeSubscribeEmbedSubscribeType.Substack
    }),
    hasNoGoalMeasuring: true,
    actionSettingsMetadata: {
        contentSettingsMetadata: {
            userId: BymoPagePropsSpecialContentSettingMetadata.Unknown
        },
        supportsActionCtaButtons: false,
        supportsContentSections: false,
        hideableContentSettingsNames: {}
    },
    actionListItemSettingsMetadata: false,
    isWidgetOpener: true,
    canRenderInPage: true,
    skipReportingOnGoalAchievedOnActionButtonClick: true,
    hasNoLockInnerCTA: true,
})